import { Box, Typography,  Card, CardContent, Grid, Link } from "@mui/material";

const BlogView = ({  blog }) => {
  return (
      <>
        <Card >
          <CardContent sx={{ flex: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={5}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  Title:
                </Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography variant="body1">{blog?.title}</Typography>
              </Grid>

              <Grid item xs={5}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  Publisher:
                </Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography variant="body1">{blog?.publisher}</Typography>
              </Grid>

              <Grid item xs={5}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  Redirectional URL:
                </Typography>
              </Grid>
              <Grid item xs={7}>
                <Link
                  href={blog?.redirectional_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="hover"
                  sx={{ wordBreak: "break-all" }}
                >
                  {blog?.redirectional_url}
                </Link>
              </Grid>
            </Grid>
            <div className="d-flex gap-2 justify-content-center mt-4">
              {blog?.cover_image && (
                <Box sx={{ mb: 2, textAlign: 'center' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                    Cover Image
                  </Typography>
                  <img
                    src={blog.cover_image}
                    alt="Cover Image"
                    style={{ maxWidth: '100%', maxHeight: '120px', borderRadius: '6px' }}
                  />
                </Box>
              )}

              {blog?.cover_video && (
                <Box sx={{ mb: 2, mt: 0, textAlign: 'center' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                    Cover Video
                  </Typography>
                  <video
                    controls
                    src={blog.cover_video}
                    style={{ maxWidth: '80%', maxHeight: '115px', borderRadius: '6px' }}
                  />
                </Box>
              )}

              {blog?.blog_desktop_banner && (
                <Box sx={{ mb: 2, textAlign: 'center' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                    Desktop 
                  </Typography>
                  <img
                    src={blog.blog_desktop_banner}
                    alt="Desktop Banner"
                    style={{ maxWidth: '100%', maxHeight: '120px', borderRadius: '6px' }}
                  />
                </Box>
              )}

              {blog?.blog_mobile_banner && (
                <Box sx={{ mb: 2, textAlign: 'center' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                    Mobile 
                  </Typography>
                  <img
                    src={blog.blog_mobile_banner}
                    alt="Mobile Banner"
                    style={{ maxWidth: '90%', maxHeight: '120px', borderRadius: '6px' }}
                  />
                </Box>
              )}
            </div>


            {blog?.text_editor && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                  Blog Content:
                </Typography>
                <Typography variant="body1" dangerouslySetInnerHTML={{ __html: blog.text_editor }} />
              </Box>
            )}
          </CardContent>
        </Card>
      </>
  );
};

export default BlogView;